<template>
    <div v-bind:class="{ 'text-center': propertyPage }">
        <template v-if="propertyPage">
            <div v-if="state" key="add"
                 class="w-46 mt-1 inline-block px-2 py-1 cursor-pointer border-solid border rounded border-gray-300 hover:border-green-700 text-lg align-middle"
                 @click="toggleFave('add')">
                <div class="inline-block align-middle" v-bind:class="{ fave_0: !adding, fave_2: adding}"></div>
                Save&nbsp;Favourite
            </div>
            <div v-else key="remove"
                 class="w-44 mt-1 inline-block px-2 py-1 cursor-pointer border-solid border rounded border-gray-300 hover:border-green-700 text-lg align-middle"
                 @click="toggleFave('remove')">
                <div class="fave_d inline-block align-middle"></div>
                Saved
            </div>
        </template>
        <template v-else>
            <div v-if="state" key="add" title="Add Favourite" v-bind:class="{ fave_0: !adding, fave_2: adding}"
                 @click="toggleFave('add')"></div>
            <div v-else key="remove" class="fave_d" title="Remove Favourite" @click="toggleFave('remove')"></div>
        </template>
    </div>
</template>
<script>
export default {
    name: "FavesComponent",
    props: ['pid', 'propertyPage'],
    data() {
        return {
            state: true,
            savedString: '',
            savedArray: [],
            adding: false,
            incremented: false,
        }
    },
    created() {
        this.getCookie();
        if (this.savedString !== null) {
            this.savedArray = this.savedString.split('-').map(Number);
            if (this.savedArray.includes(this.pid)) {
                this.state = false
            }
        }
    },
    methods: {
        toggleFave(action) {
            this.getCookie();
            if (this.savedString !== null) {
                this.savedArray = this.savedString.split('-').map(Number);
            }

            if (action === 'add') {
                this.adding = true
                setTimeout(() => {
                    this.state = false;
                    this.adding = false;
                }, 1000);

                this.savedArray.push(this.pid);
                this.savedString = this.savedArray.join('-');
                this.setCookie()
                this.incrementCount()

            }
            if (action === 'remove') {
                if (this.savedArray.includes(this.pid)) {
                    this.savedArray = this.savedArray.filter(item => item !== this.pid);
                    this.savedString = this.savedArray.join('-');
                    if (this.savedString) {
                        this.setCookie()
                    } else {
                        this.deleteCookie()
                    }
                    this.state = true
                }
            }
        },
        getCookie() {
            let v = document.cookie.match('(^|;) ?' + 'simplyowners_faves' + '=([^;]*)(;|$)');
            this.savedString = v ? v[2] : null;
        },
        setCookie() {
            let d = new Date;
            d.setFullYear(d.getFullYear() + 1);
            document.cookie = "simplyowners_faves" + "=" + this.savedString + ";path=/;expires=" + d.toGMTString();
        },
        deleteCookie() {
            document.cookie = "simplyowners_faves=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
        },
        incrementCount() {
            if (this.incremented === false) {
                axios.post('/favourites/', {
                    id: this.pid,
                });
            }
            this.incremented = true;
        }
    }
}
</script>


